import React from 'react';
import { useGroupContext } from '../../../context/GroupContext';
import BenefitGroupTable from './BenefitGroupTable';
import ManageGroup from './ManageGroup';

export const BenefitGroup = () => {
  const { selectedBenefitIdx, setBenefitIdx } = useGroupContext();

  return (
    <div className="p-1 mb-6">
      {selectedBenefitIdx !== null ? (
        <ManageGroup name={`groups.${selectedBenefitIdx}`} onBackClick={() => setBenefitIdx(null)} />
      ) : (
        <BenefitGroupTable onManage={setBenefitIdx} />
      )}
    </div>
  );
};
